import { DatePipe } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule, Meta } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AlertComponent } from './core/components/alert/alert.component';
import { ErrorInterceptor } from './core/interceptor/error/error.interceptor';
import { AuthCookieInterceptor } from './core/interceptor/jwt/auth-cookie.interceptor';
import { PrivateModule } from './private/private.module';
import { PublicModule } from './public/public.module';
import { SuperAdminModule } from './super-admin/super-admin.module';
import { QuickApiModule } from './quick-api/quick-api.module';
export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http);
}

@NgModule({ declarations: [AppComponent, AlertComponent],
    bootstrap: [AppComponent], imports: [BrowserModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient],
            },
        }),
        AppRoutingModule,
        PublicModule,
        PrivateModule,
        QuickApiModule,
        SuperAdminModule,
        BrowserAnimationsModule], providers: [
        Meta,
        { provide: HTTP_INTERCEPTORS, useClass: AuthCookieInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
        DatePipe,
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AppModule {}
